export const fileNameHelper = (page: string) => {
  const date = new Date().toISOString().slice(0, 10);
  return `${page}.${date}`;
};
